import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Auth from "../../auth/Auth";
import Spinner from "../../shared/spinner/Spinner";
import { Toast } from "../../shared/toaster/Toaster";

function PaymentSuccess() {
  const location = useLocation();
  // console.log(location, location.search);

  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });
  //Hit the backend Paypal sucess api

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  //remove excursion code

  async function SucessApi(search) {
    const res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/paypal/success?${
        search.split("?")[1].split("&")[0]
      }&platform=web`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (res.status === 200) {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/web/cart`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-token": Auth.getToken(),
          },
        }
      );
      if (response.status === 200) {
        // alert("xcart removed");
        setLoading(false);
      }
    }
    // const resp = await res.json();

    // console.log(resp, "res", res);
    // alert(resp.message);
  }
  useEffect(() => {
    location.search && SucessApi(location.search);
  }, [location.search]);
  return (
    <>
       {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />
      <div className="modalbg">
        <div className="order_com_modal">
          <div className="order_com_modal_inner">
            <div className="heading_top">
              <h2 className="everyday_color">ThankYou!</h2>
            </div>
            <div className="img_center_verified">
              <svg width="135" height="135" viewBox="0 0 135 135">
                <defs></defs>
                <path
                  style={{ fill: "#4e74f6" }}
                  d="M133.443,63.115,121.679,49.07l1.645-18.6a6.6,6.6,0,0,0-4.87-7.056L101,19.33,91.888,3.241a6.231,6.231,0,0,0-7.97-2.7L67.536,7.857,51.154.537a6.155,6.155,0,0,0-7.906,2.7L34.076,19.264,16.682,23.353a6.51,6.51,0,0,0-4.934,6.99L13.393,49,1.565,63.115a6.832,6.832,0,0,0,0,8.7L13.393,85.864l-1.645,18.661a6.6,6.6,0,0,0,4.87,7.056l17.457,4.154,9.108,16.024a6.252,6.252,0,0,0,7.97,2.7l16.382-7.451,16.382,7.319a6.155,6.155,0,0,0,7.906-2.7l9.108-16.024,17.457-4.154a6.535,6.535,0,0,0,4.87-7.056l-1.645-18.6L133.38,71.753a6.668,6.668,0,0,0,.063-8.638Zm-77.1,23.013L42.932,72.149a6.6,6.6,0,0,1-1.367-2.133,6.833,6.833,0,0,1,0-5.032,6.6,6.6,0,0,1,1.367-2.133,6.3,6.3,0,0,1,2.046-1.425,6.069,6.069,0,0,1,4.827,0,6.3,6.3,0,0,1,2.046,1.425l8.918,9.3L83.159,48.806A6.3,6.3,0,0,1,85.2,47.381a6.069,6.069,0,0,1,4.827,0,6.3,6.3,0,0,1,2.046,1.425,6.6,6.6,0,0,1,1.367,2.133,6.833,6.833,0,0,1,0,5.032A6.6,6.6,0,0,1,92.077,58.1L65.259,86.062a6.066,6.066,0,0,1-8.918.066Z"
                />
              </svg>
            </div>
            <p className="mt-5 mb-5">
              Are you sure, you want to share the user details
            </p>
            <div className="order_complete_btn">
              <Link to={`/user-details?token=${query.get("token")}`}>
                <button className="">Yes</button>
              </Link>
              <p className="mt-4 mb-4">OR</p>
              <Link to={`/?id=${Auth.getCompanyHexaID()}`}>
                <button type="button" className="back_order">
                  Back to home
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
function CancelSuccess() {
  return (
    <div className="modalbg">
      <div className="order_com_modal">
        <div className="order_com_modal_inner">
          <div className="heading_top">
            <h2 className="everyday_color">Order Cancled</h2>
          </div>
          <div className="img_center_verified">
            <svg width="65" height="64" viewBox="0 0 33 32" fill="none">
              <g clip-path="url(#clip0_1367_11011)">
                <path
                  d="M16.5 0C7.67725 0 0.5 7.17725 0.5 16C0.5 24.8228 7.67725 32 16.5 32C25.3228 32 32.5 24.8228 32.5 16C32.5 7.17725 25.3228 0 16.5 0Z"
                  fill="#FF4040"
                />
                <path
                  d="M22.3919 20.0066C22.9132 20.5281 22.9132 21.3706 22.3919 21.8921C22.2682 22.0161 22.1213 22.1144 21.9595 22.1814C21.7976 22.2485 21.6242 22.2829 21.449 22.2827C21.1078 22.2827 20.7665 22.1521 20.5064 21.8921L16.4999 17.8853L12.4933 21.8921C12.3696 22.0161 12.2227 22.1145 12.0609 22.1815C11.8991 22.2485 11.7257 22.2829 11.5506 22.2828C11.3755 22.2829 11.202 22.2485 11.0402 22.1815C10.8784 22.1145 10.7315 22.0161 10.6078 21.8921C10.0865 21.3706 10.0865 20.5281 10.6078 20.0066L14.6146 16L10.6077 11.9934C10.0865 11.4719 10.0865 10.6294 10.6077 10.1079C11.1292 9.5867 11.9718 9.5867 12.4933 10.1079L16.4999 14.1148L20.5064 10.1079C21.0279 9.58664 21.8705 9.58664 22.3919 10.1079C22.9132 10.6294 22.9132 11.4719 22.3919 11.9934L18.3851 16L22.3919 20.0066Z"
                  fill="#FAFAFA"
                />
              </g>
              <defs>
                <clipPath id="clip0_1367_11011">
                  <rect
                    width="32"
                    height="32"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="order_complete_btn">
            <Link to={`/?id=${Auth.getCompanyHexaID()}`}>
              <button type="button" className="back_order_cancle">
                Back to home
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PaymentSuccess, CancelSuccess };
